export const environment = {
  production: false,
  contactUs: 'https://bigelementinfotech.com/contact',
};